import React from 'react';
var ProContext = /*#__PURE__*/React.createContext({
  // 为未接入权限的工程 提供默认值
  isAuth: function isAuth() {
    return true;
  }
});
export default ProContext;